/**
 * Utility functions for mapping between steps and source groups
 */

// Mapping between step keys and their corresponding source group keys
export const STEP_TO_SOURCE_GROUP_MAP: Record<string, string> = {
  planet: 'planet',
  people: 'people',
  policy: 'policy',
};

/**
 * Get the source group key for a given step key
 * @param stepKey - The step key to map
 * @returns The corresponding source group key, or null if not found
 */
export const getSourceGroupForStep = (stepKey: string): string | null => {
  return STEP_TO_SOURCE_GROUP_MAP[stepKey] || null;
};

/**
 * Check if a step has a corresponding source group
 * @param stepKey - The step key to check
 * @returns True if the step has a corresponding source group
 */
export const hasSourceGroup = (stepKey: string): boolean => {
  return stepKey in STEP_TO_SOURCE_GROUP_MAP;
};
